import { useEffect, useState } from 'react';

import MaterialIcon from 'components/atoms/MaterialIcon';
import TooltipFloating from 'components/molecules/tooltipFloating';
import { TOASTER_TYPE } from 'constants/toasterMessages';
import { useAppServices } from 'container/depContext';
import { isApiError } from 'container/models';
import { IFreshdeskTokenRepo } from 'container/services/freshdeskToken/IFreshdeskTokenRepo';
import useToaster from 'hooks/useToaster';

import styles from './styles.module.scss';

function setupWidgetAuth(
  repo: IFreshdeskTokenRepo,
  successCallback: (success: boolean) => void
) {
  function authenticate() {
    repo.getFreshdeskToken().then((response) => {
      if (isApiError(response)) {
        console.error(`Couldn't get FreshDesk widget token`, response);
        successCallback(false);
        return;
      }

      FreshworksWidget('authenticate', {
        token: response.token,
        callback: authenticate,
      });

      successCallback(true);
    });
  }

  authenticate();
}

export default function HelpButton(): JSX.Element {
  const { getFreshdeskTokenRepo } = useAppServices();
  const repo = getFreshdeskTokenRepo();
  const { addToaster } = useToaster();

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    setupWidgetAuth(repo, setIsAuthenticated); // authenticate the widget on mount
    return () => FreshworksWidget('logout'); // logout the widget on unmount

    // We only want to run this effect once per mount/unmount
  }, [repo]);

  const altText = isAuthenticated
    ? 'Help'
    : 'Help is not available at this time. Please try again later.';

  return (
    <TooltipFloating useDefaultWidthAndHeight tooltipChildren={altText}>
      <button
        onClick={() =>
          isAuthenticated
            ? FreshworksWidget('open')
            : addToaster({
                message: altText,
                type: TOASTER_TYPE.ERROR,
              })
        }
        className={[
          styles.wrapper,
          isAuthenticated ? '' : styles.disabled,
        ].join(' ')}
      >
        <MaterialIcon
          name={'help'}
          alt={''}
          size={34}
          weight={300}
          className={styles.icon}
          color=""
        />
      </button>
    </TooltipFloating>
  );
}
